module.exports = __webpack_public_path__ + "img/Mapa_Vacio_Ids_Optimos.12969660.svg";